module.exports = __webpack_public_path__ + "img/info02.749e423b.png";